import { render } from "./EventsManager.vue?vue&type=template&id=705d3ed0&scoped=true"
import script from "./EventsManager.vue?vue&type=script&lang=js"
export * from "./EventsManager.vue?vue&type=script&lang=js"

import "./EventsManager.vue?vue&type=style&index=0&id=705d3ed0&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705d3ed0"]])

export default __exports__